import { ClipboardIcon } from "@heroicons/react/20/solid";
import { format, parse } from "date-fns";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { roundTo2 } from "../../common/validation/Validators";
import { copyToClipboard } from "@/helpers/ClipboardHelpers";

const AttachmentPaymentRow = ({ isLast, currency, payment, isAdmin, payrollLink }) => {
	const { id, note, amount, date } = { ...payment };
	return (
		<div
			key={`attachmentOfEarnings${id}`}
			style={{
				display: "grid",
				gridGap: "1.5rem",
				grid: "1.5rem",
				gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
				padding: "1rem",
				borderBottom: isLast ? undefined : "solid rgb(244,244,244) 4px",
			}}
		>
			<div style={{ gridColumn: "span 1 / span 4", textAlign: "center" }}>
				<h5>{date ? format(parse(date, "yyyy-MM-dd", new Date()), "dd MMM yyyy") : null}</h5>
			</div>
			<div style={{ gridColumn: "span 1 / span 4", textAlign: "center" }}>
				<h5>
					{currency}
					{roundTo2(amount)}
				</h5>
			</div>
			<div style={{ gridColumn: "span 1 / span 4", textAlign: "center" }}>
				<h5>{note}</h5>
			</div>
			<div style={{ gridColumn: "span 1 / span 4", textAlign: "center" }}>
				{isAdmin && (
					<div
						className="btn btn-xs btn-default"
						type="button"
						onClick={() => copyToClipboard(id)}
						style={{ marginRight: 5 }}
					>
						<ClipboardIcon
							className="h-5 w-5 text-dark-gray"
							style={{ marginTop: "3px" }}
						/>
					</div>
				)}
				{payrollLink ? (
					<Link
						to={`/organisation/payroll/${payrollLink}`}
						className="btn btn-xs btn-primary"
					>
						Go To Payroll
					</Link>
				) : null}
			</div>
		</div>
	);
};

const mapStateToProps = (state, ownProps) => {
    const { periodId } = { ...ownProps.payment }
    return {
        currency: state.company?.settings?.currency,
        isAdmin: state?.my?.profile?.isAdmin,
        payrollLink: periodId ? state.payPeriods?.periods?.find(item => item.id == periodId)?.link : null
    };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(AttachmentPaymentRow);
